export const START_LOADING = "[review] START_LOADING";
export const STOP_LOADING = "[review] STOP_LOADING";
export const DO_SELECT_FILTER = "[review] DO_SELECT_FILTER";
export const ENTITY_SELECTED = "[review] ENTITY_SELECTED";
export const DO_DESELECT_FILTER = "[review] DO_DESELECT_FILTER";
export const UPDATE_FILTER_OPTIONS = "[review] UPDATE_FILTER_OPTIONS";
export const REVIEW_CLEAR_STATE = "[review] REVIEW_CLEAR_STATE";
